import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-common-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './common-list.component.html',
  styleUrl: './common-list.component.scss'
})
export class CommonListComponent {
  @Input() items: string[] = []; 
  @Input() isOrderedList: boolean = false;
  @Input() listStyle: any = {};
  @Input() itemStyle: any = {};
}
